var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTender(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0245 2.5514L16.6977 5.22452C17.4344 5.96128 17.4344 7.16088 16.6977 7.89764L15.3564 9.23892L10.0196 3.89268L11.3514 2.56084C12.0882 1.81463 13.2878 1.81463 14.0245 2.5514ZM8.67849 5.22461L6.00537 7.89773L18.0297 19.9221C18.7665 20.6588 19.966 20.6588 20.7028 19.9221C21.4396 19.1853 21.4396 17.9857 20.7028 17.2489L8.67849 5.22461ZM12.3902 20.1109H2.94457C2.42505 20.1109 2 20.536 2 21.0555C2 21.575 2.42505 22.0001 2.94457 22.0001H12.3902C12.9097 22.0001 13.3348 21.575 13.3348 21.0555C13.3348 20.536 12.9097 20.1109 12.3902 20.1109ZM10.0192 14.5757L4.67298 9.22949L3.34115 10.5613C2.60438 11.2981 2.60438 12.4977 3.34115 13.2344L6.01427 15.9076C6.75103 16.6443 7.95062 16.6443 8.68739 15.9076L10.0192 14.5757Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTender);
export default __webpack_public_path__ + "static/media/tender.d538fae172156b0101284186be14099b.svg";
export { ForwardRef as ReactComponent };